import {uuid} from "../../../types/veboxModels";
import {RestDataLoader} from "../../../dashboard/widgets/unilever/RestDataLoader";
import {DeviceSlaveSettings} from "../models/DeviceSlaveSetting";
import {SettingToUpdate} from "../models/UpdatingSetting";

export const BASE_URL = "devices/slaves/";
export const BASE_RW_URL = BASE_URL + "rw/";
export const getBaseUrl = (deviceGuid: uuid,
                           rw: boolean = true) => rw ? `${BASE_RW_URL}${deviceGuid}/` : `${BASE_URL}${deviceGuid}/`;

export function updateDeviceSlaveSettings(deviceGuid: uuid,
                                          params: SettingToUpdate[]): Promise<DeviceSlaveSettings> {
    const settings = {
        settings: params
    }
    const parameters = {
        settings: settings
    }
    return new Promise<DeviceSlaveSettings>((res, rej) => {
        RestDataLoader.putJSON(
            `${getBaseUrl(deviceGuid)}configuration/readAndWrite`,
            parameters,
            res,
            rej
        )
    })
}